export const frenchFormatMappings: Record<string, string> = {
  // Long month formats with full weekday
  'iiii, MMMM d, yyyy': 'iiii d MMMM yyyy',
  'iiii, MMMM do, yyyy': 'iiii d MMMM yyyy',
  'EEEE, MMMM d, yyyy': 'EEEE d MMMM yyyy',
  'EEEE, MMMM do, yyyy': 'EEEE d MMMM yyyy',
  'iiii MMMM d, yyyy': 'iiii d MMMM yyyy',
  'EEEE MMMM d, yyyy': 'EEEE d MMMM yyyy',

  // Long month formats without weekday
  'MMMM d, yyyy': 'd MMMM yyyy',
  'MMMM do, yyyy': 'd MMMM yyyy',
  'd MMMM, yyyy': 'd MMMM yyyy',
  'yyyy, MMMM d': 'd MMMM yyyy',
  'yyyy MMMM d': 'd MMMM yyyy',

  // Short month formats with full weekday
  'iiii, MMM d, yyyy': 'iiii d MMM yyyy',
  'iiii, MMM do, yyyy': 'iiii d MMM yyyy',
  'EEEE, MMM d, yyyy': 'EEEE d MMM yyyy',
  'EEEE, MMM do, yyyy': 'EEEE d MMM yyyy',
  'iiii MMM d, yyyy': 'iiii d MMM yyyy',
  'EEEE MMM d, yyyy': 'EEEE d MMM yyyy',

  // Short month formats without weekday
  'MMM d, yyyy': 'd MMM yyyy',
  'MMM do, yyyy': 'd MMM yyyy',
  'd MMM, yyyy': 'd MMM yyyy',
  'yyyy, MMM d': 'd MMM yyyy',
  'yyyy MMM d': 'd MMM yyyy',

  // 2-digit year variations
  'MMMM d, yy': 'd MMMM yy',
  'MMM d, yy': 'd MMM yy',
  'd MMMM, yy': 'd MMMM yy',
  'yy, MMMM d': 'd MMMM yy',
  'yy MMMM d': 'd MMMM yy',
  'yy, MMM d': 'd MMM yy',
  'yy MMM d': 'd MMM yy',

  // Numeric formats
  'MM/dd/yyyy': 'dd/MM/yyyy',
  'M/d/yyyy': 'd/M/yyyy',
  'MM/dd/yy': 'dd/MM/yy',
  'M/d/yy': 'd/M/yy',
  'yyyy/MM/dd': 'dd/MM/yyyy',
  'yy/MM/dd': 'dd/MM/yy',

  // ISO and hyphenated formats
  'yyyy-MM-dd': 'dd-MM-yyyy',
  'yy-MM-dd': 'dd-MM-yy',
  'MM-dd-yyyy': 'dd-MM-yyyy',
  'M-d-yyyy': 'd-M-yyyy',

  // Dot formats
  'MM.dd.yyyy': 'dd.MM.yyyy',
  'M.d.yyyy': 'd.M.yyyy',
  'yyyy.MM.dd': 'dd.MM.yyyy',
}
